<template>
  <div class="row">
    <div class="page-title">
      <div class="row">
        <div class="col-sm-6 col-12">
          <h2>
            Ride Details
            <span class="fs-4" v-if="rideData && rideData.rideStatus" v-html="rideStatus(rideData.rideStatus)"></span>
          </h2>
        </div>
        <div class="col-sm-6 col-12 text-end">
          <button 
            v-if="rideData && canCancelRide" 
            class="btn btn-danger"
            @click="showCancelRideModal">
            <i class="fa-solid fa-xmark"></i>
            Cancel Ride
          </button>
        </div>
      </div>
    </div>

    <div v-if="rideData" class="row">
      <!-- Map   -->
      <div class="col-12">
        <div class="card">
          <div id="map" style=" height: 45vh; width: 100%;"></div>
        </div>
      </div>
    </div>

    <!--Ride information card-->
    <div class="col-sm-6">
      <div class="col-12">
        <div class="card height-equal">
          <div class="card-header">
            <h3>Ride Information</h3>
          </div>
          <div v-if="rideData" class="card-body pt-2">
            <ul>
              <li class="d-flex align-items-center gap-2 border-bottom pb-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Status</h5>
                </div>
                <div class="recent-text">
                  <h5 v-html="rideStatus(rideData.rideStatus)"></h5>
                </div>
              </li>
              <li class="d-flex align-items-center gap-2 border-bottom py-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Booking Type</h5>
                </div>
                <div class="recent-text">
                  <h5 v-html="rideType(rideData.bookingType)"></h5>
                </div>
              </li>
              <li class="d-flex align-items-center gap-2 border-bottom py-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Ordered On</h5>
                </div>
                <div class="recent-text">
                   <span v-if="rideData.orderDateTime">
                      {{ formatDate(rideData.orderDateTime) }}
                    </span>
                  <span v-else> N/A</span>
                </div>
              </li>
              <li v-if="rideData.dispatcherFullName" class="d-flex align-items-center gap-2 border-bottom py-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Dispatcher</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <a :href="`/service-provider/${props.spId}/dispatch-user/${rideData.dispatcherId}`"
                       class="fs-6 link-primary" target="_blank">
                      {{ rideData.dispatcherFullName }} <i class="fa-solid fa-arrow-up-right-from-square"></i>
                    </a>
                  </h5>
                </div>
              </li>
              <li v-for="row in fareBreakdown" :key="row.label"
                  class="d-flex align-items-center gap-2 pt-2">
                <div class="flex-grow-1">
                  <h5>{{ row.label }}</h5>
                </div>
                <div class="recent-text">
                  <h5>{{ row.amount }}</h5>
                </div>
              </li>
              <li class="d-flex align-items-center gap-2 pt-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Ride Cost</h5>
                </div>
                <div class="recent-text">
                  <h5 class="f-w-700">{{ rideCost }}</h5>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!--Location and Distance Card-->
    <div class="col-sm-6">
      <div class="col-12">
        <div class="card height-equal">
          <div class="card-header">
            <h3>Location & Distance Information</h3>
          </div>

          <div v-if="rideData" class="card-body pt-2">
            <ul>
              <li class="d-flex align-items-center gap-2 border-bottom pb-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Pickup Location</h5>
                </div>
                <div class="recent-text">
                  <h5>{{ rideData.originLocationData.address }}</h5>
                </div>
              </li>
              <li class="d-flex align-items-center gap-2 border-bottom py-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Destination</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span v-if="rideData.destinationLocationData.address">
                      {{ rideData.destinationLocationData.address }}
                    </span>
                    <span v-else>
                      N/A
                    </span>
                  </h5>
                </div>
              </li>
              <li class="d-flex align-items-center gap-2 border-bottom py-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Distance</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span v-if="rideData.distanceFormatted">
                      {{ rideData.distanceFormatted }}
                    </span>
                    <span v-else> N/A</span>
                  </h5>
                </div>
              </li>
              <li class="d-flex align-items-center gap-2 border-bottom py-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Ride Start Time</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span v-if="rideData.orderFulfilmentDateTime">
                      {{ formatDate(rideData.orderFulfilmentDateTime) }}
                    </span>
                    <span v-else> N/A</span>
                  </h5>
                </div>
              </li>
              <li class="d-flex align-items-center gap-2 pt-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Ride Duration</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span v-if="rideData.durationFormatted">
                      {{ rideData.durationFormatted }}
                    </span>
                    <span v-else> N/A</span>
                  </h5>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!--Driver Information card-->
    <div class="col-sm-6">
      <div class="col-12">
        <div class="card height-equal-2">
          <div class="card-header d-flex justify-content-between">
            <h3>Driver Information</h3>

            <a v-if="rideData && rideData.driver" class="btn btn-sm btn-outline-primary"
               :href="`/service-provider/${props.spId}/driver/${rideData.driver.id}`" target="_blank">
              Details <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </a>
          </div>

          <div v-if="rideData" class="card-body pt-2">
            <ul>
              <li class="d-flex align-items-center gap-2 pt-2 border-bottom">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Name</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span v-if="rideData.driver && rideData.driver.fullName">
                      {{ rideData.driver.fullName }}

                    </span>
                    <span v-else> N/A</span>
                  </h5>
                </div>
              </li>

              <li class="d-flex align-items-center gap-2 py-2 border-bottom">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Email</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span v-if="rideData.driver && rideData.driver.email">
                      {{ rideData.driver.email }}
                    </span>
                    <span v-else> N/A</span>
                  </h5>
                </div>
              </li>

              <li class="d-flex align-items-center gap-2 py-2 border-bottom">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Phone Number</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span v-if="rideData.driver && rideData.driver.phoneNumber">
                      {{ rideData.driver.phoneNumber }}
                    </span>
                    <span v-else> N/A</span>
                  </h5>
                </div>
              </li>

              <li class="d-flex align-items-center gap-2 pt-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Rating</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span v-if="rideData.driver && rideData.driver.rating">
                      {{ rideData.driver.rating }}/5
                    </span>
                    <span v-else> N/A</span>
                  </h5>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!--Rider Information card-->
    <div class="col-sm-6">
      <div class="col-12">
        <div class="card height-equal-2">
          <div class="card-header d-flex justify-content-between">
            <h3>Rider Information</h3>
          </div>

          <div v-if="rideData" class="card-body pt-2">
            <ul>
              <li class="d-flex align-items-center gap-2 pt-2 border-bottom">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Name</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span v-if="rideData.rider && rideData.rider.fullName">
                      {{ rideData.rider.fullName }}

                    </span>
                    <span v-else> N/A</span>
                  </h5>
                </div>
              </li>

              <li class="d-flex align-items-center gap-2 py-2 border-bottom">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Email</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span v-if="rideData.rider && rideData.rider.email">
                      {{ rideData.rider.email }}
                    </span>
                    <span v-else> N/A</span>
                  </h5>
                </div>
              </li>
              <li class="d-flex align-items-center gap-2 pt-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Phone Number</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span v-if="rideData.rider && rideData.rider.phoneNumber">
                      {{ rideData.rider.phoneNumber }}
                    </span>
                    <span v-else> N/A</span>
                  </h5>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-6">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h3>Payment Information</h3>
          </div>

          <div v-if="rideData" class="card-body pt-2">
            <div v-if="!ridePaymentTransaction" class="text-center py-3">
              <h5 class="text-muted">Payment Pending</h5>
            </div>
            <ul v-else>
              <li class="d-flex align-items-center gap-2 pt-2 border-bottom">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Payment Method</h5>
                </div>
                <div class="recent-text">
                  <h5>{{ formatPaymentMethod(ridePaymentTransaction.paymentMethod) }}</h5>
                </div>
              </li>

              <li class="d-flex align-items-center gap-2 py-2 border-bottom">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Payment Status</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    <span :class="getPaymentStatusClass(ridePaymentTransaction.transactionStatus)">
                      {{ formatPaymentStatus(ridePaymentTransaction.transactionStatus) }}
                    </span>
                  </h5>
                </div>
              </li>

              <li class="d-flex align-items-center gap-2 pt-2">
                <div class="flex-grow-1">
                  <h5 class="f-w-700">Amount Paid</h5>
                </div>
                <div class="recent-text">
                  <h5>
                    {{ formatAmount(ridePaymentTransaction.totalAmount || ridePaymentTransaction.amount, ridePaymentTransaction.currency) }}
                  </h5>
                </div>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {rideStatus, rideType} from "../utility/DatatableRenderer";
import {onMounted, ref, computed} from "vue";
import _ from 'lodash';
import moment from "moment";
import Swal from "../../extras/js/sweetalert/sweetalert2.min";
import {showToast} from "../utility/toastNotificationUtility";
// Google Maps API is loaded via script tag

const props = defineProps({
  rideId: {type: String, required: true},
  googleMapsApiKey: {type: String, required: false},
  spId: {type: String, required: true}
});

const initialCoordinates = {lat: 46.255803, lng: -63.136968};
const zoomLevel = 11;
let map = null;
let googleMaps = null; // Google Maps API reference
let directionsService = null;
let directionsRenderer = null;
const markers = ref([]);

// Ride statuses that indicate an in-session ride
const IN_SESSION_STATUSES = ['TO_PICKUP', 'WAITING_PICKUP', 'STOPPED', 'IN_PROGRESS'];

const rideData = ref(undefined);

// Computed property to extract the most recent RIDE_PAYMENT transaction
const ridePaymentTransaction = computed(() => {
  if (!rideData.value || !rideData.value.transactions || rideData.value.transactions.length === 0) {
    return null;
  }
  
  // Filter for RIDE_PAYMENT transactions
  const ridePayments = rideData.value.transactions.filter(t => t.transactionType === 'RIDE_PAYMENT');
  
  if (ridePayments.length === 0) {
    return null;
  }
  
  // Sort by createdAt (most recent first) and return the first one
  const sorted = ridePayments.sort((a, b) => {
    const dateA = new Date(a.createdAt || 0);
    const dateB = new Date(b.createdAt || 0);
    return dateB - dateA;
  });
  
  return sorted[0];
});

// The itemised fare, in the same order and under the same names as the emailed receipt, except that
// the receipt shows one combined Taxes row where this screen keeps both. Dispatchers quote riders
// from this screen, so a figure here that disagrees with the receipt reads to the rider as a
// billing error.
const money = (amount) => '$' + _.toNumber(amount || 0).toFixed(2);

const fareBreakdown = computed(() => {
  const fare = rideData.value?.rideFare;
  if (!fare) {
    return [];
  }

  const taxLabel = rideData.value?.serviceJurisdiction?.taxLabel || 'HST';
  const rows = [
    {label: 'Base Fare', amount: fare.baseFare, always: true},
    {label: 'Distance Fare', amount: fare.distanceFare, always: true},
    {label: 'Time Fare', amount: fare.perMinuteFare},
    {label: 'Zone Surcharge', amount: fare.geoZoneSurcharge},
    {label: 'Stop Charges', amount: fare.stopFare},
    {label: 'Additional Passengers', amount: fare.passengerSurcharge},
    {label: 'Scheduled Ride Fee', amount: fare.scheduledRideFee},
    {label: 'Platform Fee', amount: fare.platformFeeFlat},
    {label: 'Insurance Fee', amount: fare.platformFeeDistance},
    {label: fareAdjustmentLabel(fare.fareAdjustmentReason), amount: fare.fareAdjustment},
    {label: 'Subtotal', amount: fare.totalFare, always: true},
    // The admin view keeps both tax lines where the rider receipt shows one total: which party
    // remits which half is exactly what support and finance open this page to check.
    //
    // Named for both fees, never for the "Platform Fee" row above: taxOnFee is charged on the whole
    // platformFee, so pairing it with the flat half alone reads as a 71% rate on a page opened
    // precisely to check the split.
    {label: taxLabel + ' on fare', amount: fare.taxOnFare},
    {label: taxLabel + ' on insurance and platform fees', amount: fare.taxOnFee},
  ];

  return rows
      .filter(row => row.always || _.toNumber(row.amount || 0) !== 0)
      .map(row => ({label: row.label, amount: money(row.amount)}));
});

// Without this row the rows above visibly fail to add up to the total, on any ride a fare floor or a
// zone cap touched.
const fareAdjustmentLabel = (reason) => {
  switch (reason) {
    case 'MINIMUM_FARE':
      return 'Minimum fare adjustment';
    case 'ZONE_MINIMUM_FARE':
      return 'Zone minimum fare adjustment';
    case 'ZONE_MAXIMUM_FARE':
      return 'Zone fare cap';
    default:
      return 'Fare adjustment';
  }
};

// totalWithTax, never totalFare: the pre-tax total is the commission base and was never the amount
// the rider paid.
const rideCost = computed(() => {
  const fare = rideData.value?.rideFare;
  return fare ? money(fare.totalWithTax ?? fare.totalFare) : '$0.00';
});

const loadRideData = async () => {
  const response = await fetch(`/api/ride/${props.rideId}`);

  if (response.ok) {
    rideData.value = await response.json();
  }
}

const initMap = () => {
  if (rideData.value) {
    // Load Google Maps API
    if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
      const script = document.createElement('script');
      const key = props.googleMapsApiKey;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&loading=async&libraries=marker&callback=initGoogleMap`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      // Define the callback function globally
      window.initGoogleMap = () => {
        createMap();
      };
    } else {
      createMap();
    }
  }
};

const createMap = () => {
  googleMaps = google.maps;
  map = new googleMaps.Map(document.getElementById("map"), {
    center: initialCoordinates,
    zoom: zoomLevel,
    mapTypeControl: true,
    streetViewControl: true,
    fullscreenControl: true,
    mapId: 'f5f337b511d9a28bc10fc480',
  });
  
  directionsService = new googleMaps.DirectionsService();
  directionsRenderer = new googleMaps.DirectionsRenderer({
    map: map,
    suppressMarkers: true, // We'll add custom markers
    polylineOptions: {
      strokeColor: '#2563EB',
      strokeWeight: 4,
      strokeOpacity: 0.8
    }
  });
  
  drawRouteAndMarkers();
};

const clearMarkers = () => {
  markers.value.forEach(marker => { marker.map = null; });
  markers.value = [];
};

// Icon size configuration
const ICON_SIZES = {
  car: { width: 30, height: 30 },
  pickup: { width: 40, height: 40 },
  destination: { width: 40, height: 40 }
};

const addMarker = (position, iconType, title) => {
  const iconPaths = {
    car: '/assets/images/car.png',
    pickup: '/assets/images/img.png',
    destination: '/assets/images/img.png'
  };

  const iconSize = ICON_SIZES[iconType];
  const iconEl = document.createElement('img');
  iconEl.src = iconPaths[iconType];
  iconEl.style.width = `${iconSize.width}px`;
  iconEl.style.height = `${iconSize.height}px`;

  const marker = new googleMaps.marker.AdvancedMarkerElement({
    position,
    map,
    content: iconEl,
    title,
  });
  markers.value.push(marker);
  return marker;
};

const drawRouteAndMarkers = () => {
  if (!rideData.value || !rideData.value.originLocationData) return;
  
  clearMarkers();
  
  const origin = rideData.value.originLocationData;
  const destination = rideData.value.destinationLocationData;
  const driver = rideData.value.driver;
  const rideStatus = rideData.value.rideStatus;
  
  // Check if ride is in session (driver actively working on it)
  const isInSession = IN_SESSION_STATUSES.includes(rideStatus);
  
  let routeOrigin, waypoints = [], routeDestination;
  if (isInSession && driver && driver.currentLocationData) {
    // For in-session rides: draw driver → pickup → destination
    routeOrigin = {
      lat: driver.currentLocationData.latitude,
      lng: driver.currentLocationData.longitude
    };
    
    // Add driver marker
    addMarker(routeOrigin, 'car', 'Driver Location');
    
    // Always show pickup location for in-session rides (shows where rider was/is)
    waypoints.push({
      location: { lat: origin.latitude, lng: origin.longitude },
      stopover: true
    });
    addMarker({ lat: origin.latitude, lng: origin.longitude }, 'pickup', 'Pickup Location');
    
    if (destination && destination.latitude) {
      routeDestination = { lat: destination.latitude, lng: destination.longitude };
      addMarker(routeDestination, 'destination', 'Destination');
    }
  } else if (isInSession) {
    // Fallback: in-session but no driver location (show pickup → destination)
    routeOrigin = { lat: origin.latitude, lng: origin.longitude };
    addMarker(routeOrigin, 'pickup', 'Pickup Location');
    
    if (destination && destination.latitude) {
      routeDestination = { lat: destination.latitude, lng: destination.longitude };
      addMarker(routeDestination, 'destination', 'Destination');
    }
  } else {
    // For other statuses: draw origin → destination
    routeOrigin = { lat: origin.latitude, lng: origin.longitude };
    addMarker(routeOrigin, 'pickup', 'Pickup Location');
    
    if (destination && destination.latitude) {
      routeDestination = { lat: destination.latitude, lng: destination.longitude };
      addMarker(routeDestination, 'destination', 'Destination');
    }
  }
  
  // Draw route only if we have both origin and destination
  if (routeOrigin && routeDestination) {
    const request = {
      origin: routeOrigin,
      destination: routeDestination,
      waypoints: waypoints,
      travelMode: googleMaps.TravelMode.DRIVING
    };
    
    directionsService.route(request, (result, status) => {
      if (status === googleMaps.DirectionsStatus.OK) {
        directionsRenderer.setDirections(result);
      } else {
        console.error('Directions request failed:', status);
        // If routing fails, at least fit bounds to markers
        fitBoundsToMarkers();
      }
    });
  } else {
    // No destination available, just fit bounds to markers
    console.warn('Cannot draw route: missing destination data');
    fitBoundsToMarkers();
  }
};

const fitBoundsToMarkers = () => {
  if (markers.value.length === 0) return;
  
  const bounds = new googleMaps.LatLngBounds();
  markers.value.forEach(marker => {
    bounds.extend(marker.position);
  });
  map.fitBounds(bounds);
  
  // Don't zoom in too much if there's only one marker
  if (markers.value.length === 1) {
    const listener = googleMaps.event.addListenerOnce(map, 'idle', () => {
      if (map.getZoom() > 15) map.setZoom(15);
    });
  }
};


const formatDate = (value) => {
  return moment(value).format('MMM DD YYYY, h:mma');
}

// Payment formatting functions
const formatPaymentMethod = (method) => {
  if (!method) return 'N/A';
  const methodMap = {
    'CARD': 'Card',
    'CASH': 'Cash',
    'POS_TERMINAL': 'POS Terminal',
    'ACCOUNT': 'Account',
    'BANK_TRANSFER': 'Bank Transfer',
    'OTHER': 'Other'
  };
  return methodMap[method] || method.replace(/_/g, ' ');
}

const formatPaymentStatus = (status) => {
  if (!status) return 'N/A';
  const statusMap = {
    'SUCCESS': 'Success',
    'PENDING': 'Pending',
    'FAILED': 'Failed',
    'CANCELLED': 'Canceled',
    'REFUNDED': 'Refunded',
    'PROCESSING': 'Processing'
  };
  return statusMap[status] || status.replace(/_/g, ' ');
}

const getPaymentStatusClass = (status) => {
  if (!status) return '';

  const classMap = {
    'COMPLETED': 'badge badge-success',
    'PENDING': 'badge badge-warning',
    'FAILED': 'badge badge-danger',
    'CANCELLED': 'badge badge-secondary',
    'REFUNDED': 'badge badge-info',
    'AUTH': 'badge badge-primary'
  };
  return classMap[status] || 'badge badge-secondary';
}

const formatAmount = (amount, currency) => {
  if (amount === null || amount === undefined) return 'N/A';
  const currencySymbol = currency === 'USD' ? '$' : currency || '$';
  return `${currencySymbol.toUpperCase()} ${_.toNumber(amount).toFixed(2)}`;
}

// Ride cancellation functionality
const CANCELLABLE_STATUSES = ['PENDING', 'ACCEPTED'];

const canCancelRide = computed(() => {
  if (!rideData.value) return false;
  return CANCELLABLE_STATUSES.includes(rideData.value.rideStatus);
});

const showCancelRideModal = async () => {
  const result = await Swal.fire({
    title: 'Cancel Ride',
    text: 'Please provide a reason for cancellation:',
    input: 'textarea',
    inputPlaceholder: 'Enter cancellation reason...',
    showCancelButton: true,
    confirmButtonText: 'Cancel Ride',
    cancelButtonText: 'Close',
    confirmButtonColor: '#dc3545',
    inputValidator: (value) => {
      if (!value || value.trim().length === 0) {
        return 'You must provide a reason for cancellation';
      }
      if (value.trim().length < 5) {
        return 'Please provide a more detailed reason (at least 5 characters)';
      }
    }
  });

  if (result.isConfirmed && result.value) {
    await cancelRide(result.value);
  }
};

const cancelRide = async (reason) => {
  try {
    const response = await fetch(`/api/ride/${props.rideId}/cancel`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        cancellationReason: reason
      })
    });

    if (response.ok) {
      showToast({
        title: 'Success',
        body: 'Ride has been cancelled successfully',
        type: 'success'
      });
      // Reload ride data to show updated status
      await loadRideData();
    } else {
      const errorText = await response.text();
      let errorMessage = 'Failed to cancel ride';
      try {
        const errorJson = JSON.parse(errorText);
        errorMessage = errorJson.message || errorMessage;
      } catch (e) {
        errorMessage = errorText || errorMessage;
      }
      throw new Error(errorMessage);
    }
  } catch (error) {
    showToast({
      title: 'Error',
      body: error.message || 'Failed to cancel ride',
      type: 'error'
    });
  }
};

onMounted(() => {
  loadRideData().then(() => {
    initMap();
  });
})
</script>

